
import request from '..'

export const getEmployeeList = (): Promise<any> => {
    return request({
        url: '/system/employee/v2/list',
        method: 'get',
    })
}

export const getEmployeeV2List = (params: {
    positionStatus: number
}): Promise<any> => {
    return request({
        url: 'system/employee/v2/list',
        method: 'get',
        params
    })
}

export const getTicketPayList = (params: {
    userId?: string
    itemId?: string
    ids?: string[]
}): Promise<any> => {
    return request({
        url: '/v4/business/query/coupon',
        method: 'get',
        params
    })
}

export const getDiscount = (data: any): Promise<any> => {
    return request({
        url: '/v4/business/settle',
        method: 'post',
        data
    })
}

export const checkOut = (data: any) => {
    return request({
        url: '/v4/business/checkout',
        method: 'post',
        data
    })
}

export const getCardItemList = (params?: any): Promise<any> => {
    return request({
        url: '/goods/card_item/all',
        method: 'get',
        params
    })
}

export const getUserDebitCard = (params?: any): Promise<any> => {
    return request({
        url: '/v4/business/getUserCard',
        method: 'get',
        params
    })
}
export const recharge = (data: any) => {
    return request({
        url: '/v4/business/recharge',
        method: 'post',
        data
    })
}

export const getCardPayList = (params: {
    "cardUse"?: {
        "amount": number,
        "id": string
    }[],
    "itemId": string,
    "type": 1 | 2, // 1项目 2商品
    "userId": string
}): Promise<any> => {
    return request({
        url: '/v4/business/query/card',
        method: 'post',
        data: params
    })
}

/**
 * 核销准备
  POST /order_verify/checkPrepare
  接口ID：236635893
  接口地址：https://app.apifox.com/link/project/4376356/apis/api-236635893
 * 
*/
export interface ICheckPrepareParams {
    /**
     * 券码类型，1-文本，2-链接
     */
    codeType: number;
    /**
     * 核销类型：1-小程序券/优惠券，3-美团，4-抖音
     */
    parseType: number;
    /**
     * 核销码
     */
    receiptCode: string;
    isMerge: number;
}

export const checkPrepare = (data: ICheckPrepareParams) => {
    return request({
        url: '/order_verify/checkPrepare',
        method: 'post',
        data
    })
}

/**
 * 确认核销
  POST /order_verify/checkVerify
  接口ID：236799108
  接口地址：https://app.apifox.com/link/project/4376356/apis/api-236799108
 */

export interface ICheckVerifyDetailList {
    /**
     * 券码类型，1-文本，2-链接
     */
    codeType: number;
    /**
     * 明细信息
     */
    detailList: DataList[];
    /**
     * 补单时间
     */
    experienceDate?: string;
    /**
     * 同行人数（女）
     */
    femaleNumber?: number;
    /**
     * 是否是体验订单，1-是，0-否
     */
    isExperience?: number;
    /**
     * 同行人数（男）
     */
    maleNumber?: number;
    /**
     * 订单ID
     */
    orderId: number;
    /**
     * 核销类型：1-小程序券，2-优惠券，3-美团，4-抖音
     */
    parseType: number;
    /**
     * 手机号
     */
    phoneNumber?: string;
    /**
     * 核销码
     */
    receiptCode: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 房间列表ID数组
     */
    roomList?: number[];
    /**
     * 门店ID
     */
    shopId?: string;
    /**
     * 用户名
     */
    userName?: string;
    [property: string]: any;
}

export interface DataList {
    /**
     * 技师ID数组
     */
    consultantList: number[];
    /**
     * 明细ID
     */
    detailId: number;
    /**
     * 项目ID
     */
    itemId: number;
    /**
     * 核销数量
     */
    number: number;
}
export const checkVerify = (data: ICheckVerifyDetailList) => {
    return request({
        url: '/order_verify/checkVerify',
        method: 'post',
        data
    })
}
/**
 * 获取房间列表
  GET /shop/room/list
 */
export const getRoomList = () => {
    return request({
        url: '/shop/room/list',
        method: 'get',
    })
}

export const getOrderDetail = (id: string, clockStatus: string) => {
    return request({
        url: '/v4/business/detail',
        method: 'get',
        params: {
            orderId: id,
            clockStatus
        }
    })
}
export const checkOutCard = (data: any) => {
    return request({
        url: '/v4/business/card',
        method: 'post',
        data
    })
}

export const saveOrder = (data: any) => {
    return request({
        url: '/v4/business/save',
        method: 'post',
        data
    })
}